import React, { useRef, useState, useContext } from "react";

import { Row, Col, Image, Button, ListGroup, Container } from "react-bootstrap";

import StoryContext from "../store/context";
import { observer } from "mobx-react-lite";
import { Typeahead, ClearButton } from "react-bootstrap-typeahead";
import ReactPanZoom from "react-image-pan-zoom-rotate";

const Photos = observer(() => {
  const [photo, setPhoto] = useState(null);
  const ref = useRef(null);
  const ref_region = useRef(null);

  let date = "";

  const click = (itemPhoto) => () => setPhoto(itemPhoto);
  const store = useContext(StoryContext);

  const chekRegion = (store, region) => {
    const isRegions =
      region &&
      (store.filterRegions.length === 0 ||
        store.filterRegions.includes(region.uuid));

    return isRegions;
  };

  return (
    <>
      <Row style={{ paddingTop: 10 }}>
        <Col>
          <input
            name="requested_order_ship_date"
            value={store.date1Photo}
            type="date"
            className="form-control"
            onChange={(event) => store.setDate1Photo(event.target.value)}
          />
        </Col>
        <Col>
          <input
            name="requested_order_ship_date"
            value={store.date2Photo}
            type="date"
            className="form-control"
            onChange={(event) => store.setDate2Photo(event.target.value)}
          />
        </Col>
        <Col>
          <Typeahead
            onChange={(value) =>
              value.length > 0 && store.setClientPhoto(value[0].link)
            }
            options={store.clients
              .filter((item) => item.active === true)
              .sort((s1, s2) =>
                s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1
              )
              .map((item) => ({
                ...item,
                label: item.name,
                link: item,
              }))}
            placeholder="Клиент..."
          >
            {({ onClear, selected }) => (
              <div className="rbt-aux">
                {!!selected.length && (
                  <ClearButton
                    onClick={() => {
                      onClear();
                      ref.current.clear();
                      ref_region.current.clear();
                      store.delClientPhoto();
                    }}
                  />
                )}
              </div>
            )}
          </Typeahead>
        </Col>
        <Col>
          <Typeahead
            ref={ref_region}
            onChange={(value) => {
              if (value.length > 0) {
                store.setRegionPhoto(value[0].link);
                ref.current.clear();
              }
            }}
            options={store.regions
              .filter(
                (item) =>
                  store.outlets
                    .filter((it) => it.client === store.clientPhoto)
                    .map((it) => it.region)
                    .includes(item) && chekRegion(store, item)
              )
              .sort((s1, s2) =>
                s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1
              )
              .map((item) => ({
                ...item,
                label: item.name,
                link: item,
              }))}
            placeholder="Область..."
          >
            {({ onClear, selected }) => (
              <div className="rbt-aux">
                {!!selected.length && (
                  <ClearButton
                    onClick={() => {
                      onClear();
                      ref.current.clear();
                      store.delRegionPhoto();
                    }}
                  />
                )}
              </div>
            )}
          </Typeahead>
        </Col>
        <Col>
          <Typeahead
            ref={ref}
            onChange={(value) =>
              value.length > 0 && store.setOutletPhoto(value[0].link)
            }
            options={store.outlets
              .filter(
                (item) =>
                  item.client === store.clientPhoto &&
                  (!store.regionPhoto
                    ? true
                    : store.regionPhoto === item.region) &&
                  chekRegion(store, item.region)
              )
              .sort((s1, s2) =>
                s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1
              )
              .map((item) => ({
                ...item,
                label: item.name,
                link: item,
              }))}
            placeholder="Точка..."
            style={{ width: 500 }}
          >
            {({ onClear, selected }) => (
              <div className="rbt-aux">
                {!!selected.length && (
                  <ClearButton
                    onClick={() => {
                      onClear();
                      store.delOutletPhoto();
                    }}
                  />
                )}
              </div>
            )}
          </Typeahead>
        </Col>
        <Col>
          <Button
            onClick={() => {
              store.getPhotoAll();
              store.getProductsByOutlet();
            }}
          >
            Получить
          </Button>
        </Col>
      </Row>
      <Row>
        <Col
          md={10}
          style={{
            maxHeight: "90vh",
            overflow: "scroll",
            marginTop: 10,
          }}
        >
          {!photo ? (
            <>
              {store.photoesAll
                .slice()
                .sort((a, b) => Date.parse(a.date) - Date.parse(b.date))
                .map((item, index) => {
                  let d = null;
                  if (item.date !== date) {
                    date = item.date;
                    d = item.date;
                  }
                  console.log(JSON.stringify(item));

                  return (
                    <>
                      <>
                        {d ? (
                          <Row style={{ padding: 15, fontSize: 20 }}>{d}</Row>
                        ) : (
                          <></>
                        )}
                      </>

                      <Image
                        key={index}
                        src={`https://change.rud.com.ua:3010/api/images/${item.image}`}
                        thumbnail
                        width={400}
                        onClick={click(item.image)}
                      />
                    </>
                  );
                })}
            </>
          ) : (
            <>
              <div
                style={{
                  height: 700,
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <ReactPanZoom
                  image={`https://change.rud.com.ua:3010/api/images/${photo}`}
                  alt="Image alt text"
                />
              </div>
              <Button onClick={() => setPhoto(null)} style={{ margin: 3 }}>
                Повернутися
              </Button>
            </>
          )}
        </Col>
        <Col>
          <ListGroup
            style={{
              maxHeight: "90vh",
              overflow: "scroll",
              marginTop: 10,
            }}
          >
            {store.productsByOutlet
              .slice()
              .sort((s1, s2) =>
                s1.product.name.toLowerCase() < s2.product.name.toLowerCase()
                  ? -1
                  : 1
              )
              .map((item) => (
                <ListGroup.Item
                  style={{ color: item.action === 0 ? "black" : "red" }}
                >
                  {item.product.name}
                </ListGroup.Item>
              ))}
          </ListGroup>
        </Col>
      </Row>
    </>
  );
});

export default Photos;
